const sameMaintenanceRequests = (previous = [], next = []) => {
  if (!Array.isArray(previous) || !Array.isArray(next)) return false
  if (previous.length !== next.length) return false

  for (let i = 0; i < previous.length; i += 1) {
    const a = previous[i]
    const b = next[i]
    if (
      a?.id !== b?.id ||
      a?.request_date !== b?.request_date ||
      a?.status !== b?.status ||
      a?.updatedAt !== b?.updatedAt
    ) {
      return false
    }
  }

  return true
}

const maintenanceRequests = (maintenanceRequests = [], action) => {
  switch (action.type) {
    case 'FETCH_MAINTENANCE_REQUESTS':
      return sameMaintenanceRequests(maintenanceRequests, action.payload)
        ? maintenanceRequests
        : action.payload
    default:
      return maintenanceRequests
  }
}
export default maintenanceRequests
